// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__1TN9O","label":"styles_label__2EDfz","selectionChip":"styles_selectionChip__3k-Ve","selectionChipKeyboardFocused":"styles_selectionChipKeyboardFocused__hhVxa"};